import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { GolfTeeTimesContent } from '../../composites/GolfTeeTimesContent';
import { SplitLayout } from '../../composites/SplitLayout';
import type { GolfTeeTimesTemplateProps } from './GolfTeeTimesTemplate.types';

export function GolfTeeTimesTemplate({
  imageUrl,
  imageAlt,
  onBack,
  stickyFooter,
  labels,
  ...contentProps
}: GolfTeeTimesTemplateProps) {
  const { stickyFooter: stickyFooterLabels, backLabel, ...contentLabels } = labels ?? {};

  return (
    <SplitLayout
      left={
        <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} backLabel={backLabel} />
      }
      right={
        <>
          <GolfTeeTimesContent {...contentProps} labels={contentLabels} />
          {stickyFooter && (
            <StickyFooter
              {...stickyFooter}
              totalLabel={stickyFooterLabels?.totalLabel}
              ctaLabel={stickyFooterLabels?.ctaLabel ?? 'Continue'}
            />
          )}
        </>
      }
      contentGap="0px"
      contentMaxWidth="100%"
      hideLeftOnMobile
    />
  );
}
